import { css } from 'styled-components';
import { breakpoint, color, font } from 'styles/globals';
import { type Theme, getColor } from 'styles/theme';

export const contributors = css<{ theme: Theme }>`
  .contributors-widget {
    padding: 0 16px;
    .title {
      padding: 0;
    }
    .authors-widget { 
      padding:0 20px;
      
      > div {
        display: flex;
        flex-direction: column;
        gap: 16px;
      }
    
      .author {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
      }

      .wp-block-image {
        margin: 0!important;

        img {
          width: 40px!important;
          height: 40px!important;
          border-radius: 30px!important;
        }

        figcaption {
          display: none;
        }

        .image-credit {
          display: none;
        }

      }
      .author-name {
        display: flex;
        flex-direction: column;
        align-items: left;
        justify-content: center;
        margin: 0;
        padding: 0;
        font-family: ${font.graphikCond};
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        letter-spacing: 0.5px;
        color: ${getColor('textSecondary')};
        @media (${breakpoint.mmMin}) {
          flex-direction: row;
          gap: 8px;
        }

        a {
          font-size: 16px;
          font-weight: 600;
          line-height: 19.2px;
          letter-spacing: 0.5px;
          text-decoration: none;
          color: ${color.recommendsDarkGreen};
          margin: 0;
          &:hover, &:focus {
            color: ${color.recommendsGreen}; 
          }
          &:focus {
            box-shadow: 0px 0px 7px 0px ${getColor('textLink')};
          }  
          &:active > *:not(.no-active) {
            color: ${color.recommendsGreen}; 
          }
          &:active {
            box-shadow: 0px 0px 7px 0px ${getColor('textLink')};
          }
        }
      }
    }
  }
`;
